module.exports = __webpack_public_path__ + "static/media/paris.43198f39.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/paris.svg
// module id = 516
// module chunks = 0